"use client";

import { EventTrackingProps } from "@/types/common";
import trackPerformance from "@/utils/performance";
import trackClevertapEvents from "@/utils/trackClevertapEvents";
import "@monsterindia/registration/styles";
import dynamic from "next/dynamic";
import React, { useEffect } from "react";

const ABTestingCookie = dynamic(() => import("@/app/helper/ABTestingCookie"), {
  ssr: false,
});

type RegistrationComponentProps = {
  handleEventTracking: (props: EventTrackingProps) => void;
};

const Registration = dynamic(
  () =>
    import("@monsterindia/registration").then(
      (mod) =>
        mod.Registration as unknown as React.FC<RegistrationComponentProps>,
    ),
  {
    ssr: false,
  },
);

const cleverTapEventTypes = {
  onUserLoginPush: "onUserLoginPush",
  eventPush: "eventPush",
  profilePush: "profilePush",
  splTrackEvent: "splTrackEvent",
  getPlatform: "getPlatform",
};

const RegistrationWrapper = () => {
  useEffect(() => {
    trackPerformance();
  }, []);

  const handleEventTracking = async (event: EventTrackingProps) => {
    const search = window.location.search;
    let urlParams = new URLSearchParams(search);
    const isApp = urlParams.get("app");
    const { eventName, eventType, eventProps, action } = event;
    if (eventProps) {
      eventProps["page_name"] = "Registration";
      if (isApp) {
        eventProps["source"] = "APP";
      }
    }

    // Handle Flutter message if authData exists
    if (
      eventType === cleverTapEventTypes.onUserLoginPush &&
      eventProps?.authData
    ) {
      try {
        if (typeof window.MessageHandler?.postMessage === "function") {
          window.MessageHandler.postMessage(
            JSON.stringify({
              type: "AUTH_TOKEN",
              data: eventProps.authData,
            }),
          );
        }
      } catch (error) {
        console.error("Error sending data to Flutter:", error);
      }
    }

    // Create clean eventProps without authData for Clevertap
    const clevertapProps = eventProps ? { ...eventProps } : {};
    if (clevertapProps.authData) {
      delete clevertapProps.authData;
    }

    switch (eventType) {
      case cleverTapEventTypes.eventPush:
        trackClevertapEvents.eventPush(eventName, clevertapProps);
        break;
      case cleverTapEventTypes.onUserLoginPush:
        trackClevertapEvents.onuserLoginPush(clevertapProps);
        break;
      case cleverTapEventTypes.profilePush:
        trackClevertapEvents.profilePush(clevertapProps);
        break;
      case cleverTapEventTypes.splTrackEvent:
        trackClevertapEvents.splTrackEvent(action, eventName, clevertapProps);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <ABTestingCookie cookieName="regVariant" cookieValue="newReg" />
      <Registration handleEventTracking={handleEventTracking} />
    </>
  );
};

export default RegistrationWrapper;
